import React from 'react';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import { TextVariant, Typography } from '@components/shared/design/Typography';
import { DONATION_PERCENTAGE } from '@constants';

const BrightFridayBanner: React.FC = () => {
  const { t } = useTranslation();
  const showBanner = process.env.SHOW_DONATION_BANNER === 'true';
  if (!showBanner) return null;

  return (
    <PromotionWrapper>
      <Sublabel>{t('donation-banner.sub-label')}</Sublabel>
      <DescriptionText $variant={TextVariant.BodyRegularLG}>
        <Trans i18nKey="donation-banner.description" values={{ percentage: `${DONATION_PERCENTAGE}%` }} components={{ span: <span /> }} />
      </DescriptionText>
    </PromotionWrapper>
  );
};

export default BrightFridayBanner;

const PromotionWrapper = styled.div`
  margin-top: 10px;
  width: 100%;
  position: relative;
  display: flex;
  padding: 16px;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${Colors.paleGold};
  background: ${Colors.cream};
  text-align: left;
`;

const Sublabel = styled.span`
  position: absolute;
  top: -10px;
  left: 17px;
  display: flex;
  padding: 3px 5px;
  border-radius: 2px;
  background: ${Colors.paleGold};
  font-family: BrownStd;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.84px;
  text-transform: uppercase;
  color: ${Colors.navyBlue};

  @media (max-width: 1300px) {
    left: 16px;
  }
`;

const DescriptionText = styled(Typography)`
  & > a,
  & > span {
    color: ${Colors.lilac};
    font-weight: 700;
  }
`;
